import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { SubNavSubMenuVariants } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  SubNavSubMenuVariants,
  React
};